export default "__VITE_ASSET__BdYUJL1t__"